<template>
  <div class="view-profile">
    <div class="d-flex justify-space-between p-4 align-center">
      <span class="heading-6 textPrimary--text font-weight-bold">
        {{ $t("settings.profile") }}
      </span>
      <VBtn
        class="mx-2"
        fab
        small
        data-test="editProfileButton"
        color="grey-lighten-4 box-shadow-elevation-6"
        @click="$emit('openForm')"
      >
        <v-icon> mdi-pencil </v-icon>
      </VBtn>
    </div>
    <div>
      <div class="d-flex justify-center mb-4">
        <VAvatar color="brandingPrimary" size="64">
          <span class="white--text text-h5 text-uppercase">{{
            firstLetters
          }}</span>
        </VAvatar>
      </div>
      <div class="d-flex justify-center">
        <div class="d-flex justify-center justify-content-center flex-wrap">
          <h6 class="heading-6 textPrimary--text">
            {{ `${profile.firstName} ${profile.lastName}` }}
          </h6>
        </div>
      </div>
      <VDivider class="mb-0" />
      <VRow class="mx-4 mt-3">
        <VCol
          cols="1"
          class="d-flex justify-content-end p-0 pr-2"
          :class="{ 'pl-2': $vuetify.breakpoint.xs }"
        >
          <VIcon v-text="'mdi-cellphone'" />
        </VCol>
        <VCol cols="10" class="p-0" :class="{ 'ml-2': $vuetify.breakpoint.xs }">
          <span class="body-1">{{ profile.phone }}</span>
        </VCol>
      </VRow>
      <VRow v-if="profile.email" class="mx-4 pt-6">
        <VCol
          cols="1"
          class="d-flex justify-content-end p-0 pr-2"
          :class="{ 'pl-2': $vuetify.breakpoint.xs }"
        >
          <VIcon v-text="'mdi-email'" />
        </VCol>
        <VCol cols="10" class="p-0" :class="{ 'ml-2': $vuetify.breakpoint.xs }">
          <span class="body-1">{{ profile.email }}</span>
        </VCol>
      </VRow>
      <VDivider class="mt-6 mb-0" />
      <VRow>
        <VCol>
          <div
            class="
              w-100
              d-flex
              justify-center justify-content-center
              align-center
            "
          >
            <VBtn
              v-if="!profile.customerDeletionRequestedTime"
              text
              color="error"
              class="body-2 mt-3"
              @click="$emit('openDeleteAccountDialog')"
            >
              {{ $t("settings.deleteAccount.title") }}
            </VBtn>
          </div>
          <SInfoblock
            v-if="profile.customerDeletionRequestedTime"
            class="mt-4 mx-4 mb-1"
            color="warning-color"
            :message="$t('settings.deleteAccount.requestSent')"
            prependIcon="mdi-information"
            prependIconColor="warning"
          />
        </VCol>
      </VRow>
    </div>
  </div>
</template>

<script lang="ts">
export default {
  name: 'ViewProfile',
};
</script>

<script setup lang="ts">
import { ref } from 'vue';
import SInfoblock from '../../common/SInfoblock.vue';

defineProps({
  profile: {
    type: Object,
    default: () => {},
  },
  firstLetters: {
    type: String,
    default: null,
  },
});

const isEditMode = ref(false);
</script>
